// src/lists/countries-list.ts
import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
var country = z.union([
  z.literal("Canada"),
  z.literal("United States"),
  z.literal("Afghanistan"),
  z.literal("Albania"),
  z.literal("Algeria"),
  z.literal("Andorra"),
  z.literal("Angola"),
  z.literal("Antigua and Barbuda"),
  z.literal("Argentina"),
  z.literal("Armenia"),
  z.literal("Australia"),
  z.literal("Austria"),
  z.literal("Azerbaijan"),
  z.literal("The Bahamas"),
  z.literal("Bahrain"),
  z.literal("Bangladesh"),
  z.literal("Barbados"),
  z.literal("Belarus"),
  z.literal("Belgium"),
  z.literal("Belize"),
  z.literal("Benin"),
  z.literal("Bhutan"),
  z.literal("Bolivia"),
  z.literal("Bosnia and Herzegovina"),
  z.literal("Botswana"),
  z.literal("Brazil"),
  z.literal("Brunei"),
  z.literal("Bulgaria"),
  z.literal("Burkina Faso"),
  z.literal("Burundi"),
  z.literal("Cabo Verde"),
  z.literal("Cambodia"),
  z.literal("Cameroon"),
  z.literal("Central African Republic"),
  z.literal("Chad"),
  z.literal("Chile"),
  z.literal("China"),
  z.literal("Colombia"),
  z.literal("Comoros"),
  z.literal("Congo, Democratic Republic of the"),
  z.literal("Congo, Republic of the"),
  z.literal("Costa Rica"),
  z.literal("C\xF4te d\u2019Ivoire"),
  z.literal("Croatia"),
  z.literal("Cuba"),
  z.literal("Cyprus"),
  z.literal("Czech Republic"),
  z.literal("Denmark"),
  z.literal("Djibouti"),
  z.literal("Dominica"),
  z.literal("Dominican Republic"),
  z.literal("East Timor (Timor-Leste)"),
  z.literal("Ecuador"),
  z.literal("Egypt"),
  z.literal("El Salvador"),
  z.literal("Equatorial Guinea"),
  z.literal("Eritrea"),
  z.literal("Estonia"),
  z.literal("Eswatini"),
  z.literal("Ethiopia"),
  z.literal("Fiji"),
  z.literal("Finland"),
  z.literal("France"),
  z.literal("Gabon"),
  z.literal("The Gambia"),
  z.literal("Georgia"),
  z.literal("Germany"),
  z.literal("Ghana"),
  z.literal("Greece"),
  z.literal("Grenada"),
  z.literal("Guatemala"),
  z.literal("Guinea"),
  z.literal("Guinea-Bissau"),
  z.literal("Guyana"),
  z.literal("Haiti"),
  z.literal("Honduras"),
  z.literal("Hungary"),
  z.literal("Iceland"),
  z.literal("India"),
  z.literal("Indonesia"),
  z.literal("Iran"),
  z.literal("Iraq"),
  z.literal("Ireland"),
  z.literal("Israel"),
  z.literal("Italy"),
  z.literal("Jamaica"),
  z.literal("Japan"),
  z.literal("Jordan"),
  z.literal("Kazakhstan"),
  z.literal("Kenya"),
  z.literal("Kiribati"),
  z.literal("Korea, North"),
  z.literal("Korea, South"),
  z.literal("Kosovo"),
  z.literal("Kuwait"),
  z.literal("Kyrgyzstan"),
  z.literal("Laos"),
  z.literal("Latvia"),
  z.literal("Lebanon"),
  z.literal("Lesotho"),
  z.literal("Liberia"),
  z.literal("Libya"),
  z.literal("Liechtenstein"),
  z.literal("Lithuania"),
  z.literal("Luxembourg"),
  z.literal("Madagascar"),
  z.literal("Malawi"),
  z.literal("Malaysia"),
  z.literal("Maldives"),
  z.literal("Mali"),
  z.literal("Malta"),
  z.literal("Marshall Islands"),
  z.literal("Mauritania"),
  z.literal("Mauritius"),
  z.literal("Mexico"),
  z.literal("Micronesia, Federated States of"),
  z.literal("Moldova"),
  z.literal("Monaco"),
  z.literal("Mongolia"),
  z.literal("Montenegro"),
  z.literal("Morocco"),
  z.literal("Mozambique"),
  z.literal("Myanmar (Burma)"),
  z.literal("Namibia"),
  z.literal("Nauru"),
  z.literal("Nepal"),
  z.literal("Netherlands"),
  z.literal("New Zealand"),
  z.literal("Nicaragua"),
  z.literal("Niger"),
  z.literal("Nigeria"),
  z.literal("North Macedonia"),
  z.literal("Norway"),
  z.literal("Oman"),
  z.literal("Pakistan"),
  z.literal("Palau"),
  z.literal("Panama"),
  z.literal("Papua New Guinea"),
  z.literal("Paraguay"),
  z.literal("Peru"),
  z.literal("Philippines"),
  z.literal("Poland"),
  z.literal("Portugal"),
  z.literal("Qatar"),
  z.literal("Romania"),
  z.literal("Russia"),
  z.literal("Rwanda"),
  z.literal("Saint Kitts and Nevis"),
  z.literal("Saint Lucia"),
  z.literal("Saint Vincent and the Grenadines"),
  z.literal("Samoa"),
  z.literal("San Marino"),
  z.literal("Sao Tome and Principe"),
  z.literal("Saudi Arabia"),
  z.literal("Senegal"),
  z.literal("Serbia"),
  z.literal("Seychelles"),
  z.literal("Sierra Leone"),
  z.literal("Singapore"),
  z.literal("Slovakia"),
  z.literal("Slovenia"),
  z.literal("Solomon Islands"),
  z.literal("Somalia"),
  z.literal("South Africa"),
  z.literal("Spain"),
  z.literal("Sri Lanka"),
  z.literal("Sudan"),
  z.literal("Sudan, South"),
  z.literal("Suriname"),
  z.literal("Sweden"),
  z.literal("Switzerland"),
  z.literal("Syria"),
  z.literal("Taiwan"),
  z.literal("Tajikistan"),
  z.literal("Tanzania"),
  z.literal("Thailand"),
  z.literal("Togo"),
  z.literal("Tonga"),
  z.literal("Trinidad and Tobago"),
  z.literal("Tunisia"),
  z.literal("Turkey"),
  z.literal("Turkmenistan"),
  z.literal("Tuvalu"),
  z.literal("Uganda"),
  z.literal("Ukraine"),
  z.literal("United Arab Emirates"),
  z.literal("United Kingdom"),
  z.literal("Uruguay"),
  z.literal("Uzbekistan"),
  z.literal("Vanuatu"),
  z.literal("Vatican City"),
  z.literal("Venezuela"),
  z.literal("Vietnam"),
  z.literal("Yemen"),
  z.literal("Zambia")
]).describe(createCustomSettings({ label: "Country" }));
var countryLookup = {
  "Cayman Islands": "",
  "United Kingdom (GB)": "United Kingdom",
  "Congo, Democratic People's Republic": "Congo, Democratic Republic of the",
  "United States of America": "United States",
  "Korea, Republic of": "Korea, South",
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AD: "Andorra",
  AO: "Angola",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BT: "Bhutan",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CV: "Cabo Verde",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  HR: "Croatia",
  CU: "Cuba",
  CY: "Cyprus",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  SZ: "Eswatini",
  ET: "Ethiopia",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GA: "Gabon",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GR: "Greece",
  GD: "Grenada",
  GT: "Guatemala",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HU: "Hungary",
  HK: "China",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IQ: "Iraq",
  IE: "Ireland",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LV: "Latvia",
  LB: "Lebanon",
  UK: "United Kingdom",
  KR: "Korea, South",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MR: "Mauritania",
  MU: "Mauritius",
  MX: "Mexico",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MA: "Morocco",
  MZ: "Mozambique",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NG: "Nigeria",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PL: "Poland",
  PT: "Portugal",
  QA: "Qatar",
  RO: "Romania",
  RW: "Rwanda",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  ES: "Spain",
  LK: "Sri Lanka",
  SR: "Suriname",
  SE: "Sweden",
  CH: "Switzerland",
  TJ: "Tajikistan",
  TH: "Thailand",
  TG: "Togo",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TW: "Taiwan",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Vietnam",
  YE: "Yemen",
  ZM: "Zambia",
  RU: "Russia"
};

// src/lists/languages-list.ts
import { z as z2 } from "zod";
import { createCustomSettings as createCustomSettings2 } from "@rootreeweb/zod-to-elements";
var language = z2.union([
  z2.literal("English (CA)").describe("English"),
  z2.literal("French (Canada)").describe("Fran\xE7ais")
]).describe(createCustomSettings2({ isRadioList: true }));

// src/lists/states-list.ts
import { z as z3 } from "zod";
import { createCustomSettings as createCustomSettings3 } from "@rootreeweb/zod-to-elements";
var state = z3.union([
  z3.literal("AK"),
  z3.literal("AL"),
  z3.literal("AR"),
  z3.literal("AZ"),
  z3.literal("CA"),
  z3.literal("CO"),
  z3.literal("CT"),
  z3.literal("DC"),
  z3.literal("DE"),
  z3.literal("FL"),
  z3.literal("GA"),
  z3.literal("HI"),
  z3.literal("IA"),
  z3.literal("ID"),
  z3.literal("IL"),
  z3.literal("IN"),
  z3.literal("KS"),
  z3.literal("KY"),
  z3.literal("LA"),
  z3.literal("MA"),
  z3.literal("MD"),
  z3.literal("ME"),
  z3.literal("MI"),
  z3.literal("MN"),
  z3.literal("MO"),
  z3.literal("MS"),
  z3.literal("MT"),
  z3.literal("NC"),
  z3.literal("ND"),
  z3.literal("NE"),
  z3.literal("NH"),
  z3.literal("NJ"),
  z3.literal("NM"),
  z3.literal("NV"),
  z3.literal("NY"),
  z3.literal("OH"),
  z3.literal("OK"),
  z3.literal("OR"),
  z3.literal("PA"),
  z3.literal("PR"),
  z3.literal("RI"),
  z3.literal("SC"),
  z3.literal("SD"),
  z3.literal("TN"),
  z3.literal("TX"),
  z3.literal("UT"),
  z3.literal("VA"),
  z3.literal("VI"),
  z3.literal("VT"),
  z3.literal("WA"),
  z3.literal("WI"),
  z3.literal("WV"),
  z3.literal("WY")
]).optional().describe(
  createCustomSettings3({
    label: "State",
    dependsOn: { field: "Country", value: "United States" }
  })
);
var stateLookup = {
  Alabama: "AL",
  Nebraska: "NE",
  Alaska: "AK",
  Nevada: "NV",
  Arizona: "AZ",
  "New Hampshire": "NH",
  Arkansas: "AR",
  "New Jersey": "NJ",
  California: "CA",
  "New Mexico": "NM",
  Colorado: "CO",
  "New York": "NY",
  Connecticut: "CT",
  "North Carolina": "NC",
  Delaware: "DE",
  "North Dakota": "ND",
  "District of Columbia": "DC",
  Ohio: "OH",
  Florida: "FL",
  Oklahoma: "OK",
  Georgia: "GA",
  Oregon: "OR",
  Hawaii: "HI",
  Pennsylvania: "PA",
  Idaho: "ID",
  "Puerto Rico": "PR",
  Illinois: "IL",
  "Rhode Island": "RI",
  Indiana: "IN",
  "South Carolina": "SC",
  Iowa: "IA",
  "South Dakota": "SD",
  Kansas: "KS",
  Tennessee: "TN",
  Kentucky: "KY",
  Texas: "TX",
  Louisiana: "LA",
  Utah: "UT",
  Maine: "ME",
  Vermont: "VT",
  Maryland: "MD",
  Virginia: "VA",
  Massachusetts: "MA",
  "Virgin Islands": "VI",
  Michigan: "MI",
  Washington: "WA",
  Minnesota: "MN",
  "West Virginia": "WV",
  Mississippi: "MS",
  Wisconsin: "WI",
  Missouri: "MO",
  Wyoming: "WY",
  Montana: "MT"
};

// src/lists/province-list.ts
import { z as z4 } from "zod";
import { createCustomSettings as createCustomSettings4 } from "@rootreeweb/zod-to-elements";
var province = z4.union([
  z4.literal("Alberta"),
  z4.literal("British Columbia"),
  z4.literal("Manitoba"),
  z4.literal("New Brunswick"),
  z4.literal("Newfoundland and Labrador"),
  z4.literal("Northwest Territories"),
  z4.literal("Nova Scotia"),
  z4.literal("Nunavut"),
  z4.literal("Ontario"),
  z4.literal("Prince Edward Island"),
  z4.literal("Quebec"),
  z4.literal("Saskatchewan"),
  z4.literal("Yukon")
]).optional().describe(
  createCustomSettings4({
    label: "Province",
    dependsOn: { field: "Country", value: "Canada" }
  })
);
var provinceLookup = {
  on: "Ontario",
  qc: "Quebec",
  "british\xA0columbia": "British Columbia",
  bc: "British Columbia",
  "british-columbia": "British Columbia",
  sk: "Saskatchewan",
  ab: "Alberta",
  mb: "Manitoba",
  "new\xA0brunswick": "New Brunswick",
  nb: "New Brunswick",
  ns: "Nova Scotia",
  "nova\xA0scotia": "Nova Scotia",
  pe: "Prince Edward Island",
  nl: "Newfoundland and Labrador",
  "northwest\xA0territories": "Northwest Territories",
  nt: "Northwest Territories",
  yt: "Yukon"
};

// src/lists/industries-list.ts
import { z as z5 } from "zod";
import { createCustomSettings as createCustomSettings5 } from "@rootreeweb/zod-to-elements";
var industry = z5.union([
  z5.literal("Agriculture"),
  z5.literal("Apparel"),
  z5.literal("Cannabis"),
  z5.literal("Coffee & Tea"),
  z5.literal("Confectionary"),
  z5.literal("Construction"),
  z5.literal("Dairy"),
  z5.literal("Entertainment"),
  z5.literal("Food"),
  z5.literal("Frozen Foods"),
  z5.literal("Granola & Cereals"),
  z5.literal("Health & Organics"),
  z5.literal("Industrial & Household Chemicals"),
  z5.literal("Liquids & Beverages"),
  z5.literal("Other"),
  z5.literal("Pet food & Treats"),
  z5.literal("Pharmaceutical"),
  z5.literal("Snacks"),
  z5.literal("Sports & Fitness")
]).describe(createCustomSettings5({ label: "Industry", isRadioList: true }));
var industryLookup = {
  "74": "Agriculture",
  "14": "Apparel",
  "1": "Cannabis",
  "18": "Coffee & Tea",
  "19": "Confectionary",
  "16": "Construction",
  "10": "Dairy",
  "2": "Entertainment",
  "6": "Food",
  "3": "Frozen Foods",
  "4": "Granola & Cereals",
  "22": "Health & Organics",
  "12": "Industrial & Household Chemicals",
  "11": "Liquids & Beverages",
  "83": "Other",
  "5": "Pet food & Treats",
  "24": "Pharmaceutical",
  "15": "Snacks",
  "21": "Sports & Fitness"
};

// src/lists/interests-list.ts
import { z as z6 } from "zod";
import { createCustomSettings as createCustomSettings6 } from "@rootreeweb/zod-to-elements";
var interestedIn = z6.union([
  z6.literal("Custom Packaging / Rollstock"),
  z6.literal("Co-Packing"),
  z6.literal("Creative Services"),
  z6.literal("Stock Packaging"),
  z6.string()
]).describe(
  createCustomSettings6({ label: "Interested In", isCheckBoxList: true })
);

// src/lists/sales-rep-list.ts
import { z as z7 } from "zod";
import { createCustomSettings as createCustomSettings7 } from "@rootreeweb/zod-to-elements";
var salesRep = z7.union([
  z7.literal("Dan Koz"),
  z7.literal("Sheela Chandan"),
  z7.literal("Siva Yogachandran"),
  z7.literal("Eva Brophy"),
  z7.literal("Ralph Petermann"),
  z7.literal("Pia Simran"),
  z7.literal("Kelly Bernier"),
  z7.literal("Annie Lefebvre"),
  z7.literal("Marie \xC8ve St-Cyr"),
  z7.literal("Bailey Few"),
  z7.literal("Mikael Gervais")
]).describe(
  createCustomSettings7({
    label: "Sales Representative"
  })
);
var repIDLookup = {
  "48575": "Annie Lefebvre",
  "30182": "Bailey Few",
  "18": "Dan Koz",
  "22": "Eva Brophy",
  "18066": "Kelly Bernier",
  "22437": "Marie \xC8ve St-Cyr",
  "38": "Pia Simran",
  "37531": "Ralph Petermann",
  "41": "Sheela Chandan",
  "27936": "Siva Yogachandran"
};

// src/lists/lead-status-list.ts
import { z as z8 } from "zod";
import { createCustomSettings as createCustomSettings8 } from "@rootreeweb/zod-to-elements";
var leadStatus = z8.union([z8.literal("LEAD-Lead"), z8.literal("PROSPECT-Prospect")]).describe(createCustomSettings8({ label: "Customer Status" }));
var customerStatus = z8.union([
  z8.literal("CUSTOMER-Active"),
  z8.literal("CUSTOMER-Lost"),
  z8.literal("CUSTOMER-Loyalist"),
  z8.literal("CUSTOMER-Needs Attention"),
  z8.literal("CUSTOMER-New"),
  z8.literal("CUSTOMER-Potential Loyalist")
]);
var allLeadStatuses = z8.union([leadStatus, customerStatus]);

// src/lists/regions-list.ts
import { z as z9 } from "zod";
var region = z9.union([
  z9.literal(""),
  z9.literal("Alberta"),
  z9.literal("British Columbia"),
  z9.literal("Manitoba"),
  z9.literal("New Brunswick"),
  z9.literal("Newfoundland and Labrador"),
  z9.literal("Nova Scotia"),
  z9.literal("Northwest\xA0Territories"),
  z9.literal("Nunavut"),
  z9.literal("Ontario"),
  z9.literal("Prince Edward Island"),
  z9.literal("Quebec"),
  z9.literal("Saskatchewan"),
  z9.literal("Yukon"),
  z9.literal("Africa"),
  z9.literal("Asia"),
  z9.literal("Australia/New Zealand"),
  z9.literal("United States"),
  z9.literal("Europe"),
  z9.literal("Central America"),
  z9.literal("South America")
]);
var regionLookup = {
  "19": "Africa",
  "4": "Alberta",
  "18": "Asia",
  "20": "Australia/New Zealand",
  "3": "British Columbia",
  "7": "Central America",
  "6": "Europe",
  "9": "Manitoba",
  "10": "New Brunswick",
  "11": "Newfoundland and Labrador",
  "15": "Northwest\xA0Territories",
  "12": "Nova Scotia",
  "16": "Nunavut",
  "1": "Ontario",
  "13": "Prince Edward Island",
  "2": "Quebec",
  "14": "Saskatchewan",
  "8": "South America",
  "5": "United States",
  "17": "Yukon",
  AB: "Alberta",
  MB: "Manitoba",
  NB: "New Brunswick",
  NS: "Nova Scotia",
  "Nova\xA0Scotia": "Nova Scotia",
  PI: "Prince Edward Island",
  ON: "Ontario",
  QC: "Quebec",
  SK: "Saskatchewan",
  BC: "British Columbia",
  NL: "Newfoundland and Labrador",
  PE: "Prince Edward Island",
  YT: "Yukon",
  Alabama: "United States",
  AL: "United States",
  Nebraska: "United States",
  NE: "United States",
  Alaska: "United States",
  AK: "United States",
  Nevada: "United States",
  NV: "United States",
  Arizona: "United States",
  AZ: "United States",
  "New Hampshire": "United States",
  NH: "United States",
  Arkansas: "United States",
  AR: "United States",
  "New Jersey": "United States",
  NJ: "United States",
  California: "United States",
  CA: "United States",
  "New Mexico": "United States",
  NM: "United States",
  Colorado: "United States",
  CO: "United States",
  "New York": "United States",
  NY: "United States",
  Connecticut: "United States",
  CT: "United States",
  "North Carolina": "United States",
  NC: "United States",
  Delaware: "United States",
  DE: "United States",
  "North Dakota": "United States",
  ND: "United States",
  "District of Columbia": "United States",
  DC: "United States",
  Ohio: "United States",
  OH: "United States",
  Florida: "United States",
  FL: "United States",
  Oklahoma: "United States",
  OK: "United States",
  Georgia: "United States",
  GA: "United States",
  Oregon: "United States",
  OR: "United States",
  Hawaii: "United States",
  HI: "United States",
  Pennsylvania: "United States",
  PA: "United States",
  Idaho: "United States",
  ID: "United States",
  "Puerto Rico": "United States",
  PR: "United States",
  Illinois: "United States",
  IL: "United States",
  "Rhode Island": "United States",
  RI: "United States",
  Indiana: "United States",
  IN: "United States",
  "South Carolina": "United States",
  SC: "United States",
  Iowa: "United States",
  IA: "United States",
  "South Dakota": "United States",
  SD: "United States",
  Kansas: "United States",
  KS: "United States",
  Tennessee: "United States",
  TN: "United States",
  Kentucky: "United States",
  KY: "United States",
  Texas: "United States",
  TX: "United States",
  Louisiana: "United States",
  LA: "United States",
  Utah: "United States",
  UT: "United States",
  Maine: "United States",
  ME: "United States",
  Vermont: "United States",
  VT: "United States",
  Maryland: "United States",
  MD: "United States",
  Virginia: "United States",
  VA: "United States",
  Massachusetts: "United States",
  MA: "United States",
  "Virgin Islands": "United States",
  VI: "United States",
  Michigan: "United States",
  MI: "United States",
  Washington: "United States",
  WA: "United States",
  Minnesota: "United States",
  MN: "United States",
  "West Virginia": "United States",
  WV: "United States",
  Mississippi: "United States",
  MS: "United States",
  Wisconsin: "United States",
  WI: "United States",
  Missouri: "United States",
  MO: "United States",
  Wyoming: "United States",
  WY: "United States",
  Montana: "United States",
  MT: "United States",
  Honduras: "Central America",
  "Dominican Republic": "Central America",
  "Cusco Peru": "Central America",
  Seoul: "Asia",
  "Dr Congo": "Africa",
  Cancun: "Central America",
  Kinshasa: "Africa",
  Washinton: "United States",
  "New York, Ny": "United States",
  "Washington, Dc": "United States",
  Caldas: "South America",
  HO: "United States",
  Colombia: "South America",
  "??": "",
  Turkey: "Europe",
  Bolivia: "South America",
  Brazil: "South America",
  Columbia: "South America",
  Panama: "Central America",
  BY: "",
  Ethiopia: "",
  US: "United States",
  Chile: "South America",
  Moyobamba: "South America",
  Kenya: "Africa",
  "Atlanta,ga": "United States",
  TBC: "",
  "Domincan Republic": "Central America",
  Ecuador: "South America",
  Iceland: "Europe",
  Ireland: "Europe",
  "N/a": "",
  MEXICO: "Central America",
  Alajuela: "Central America",
  Greece: "Europe",
  Ghana: "Africa",
  "British Columbia": "British Columbia",
  "Nova Scotia": "Nova Scotia",
  Peru: "Central America",
  "New Zealand": "Australia/New Zealand",
  India: "Asia",
  "United Kingdom": "Europe",
  Italy: "Europe",
  Argentina: "South America",
  Sweden: "Europe",
  Switzerland: "Europe",
  "Antigua and Barbuda": "Central America",
  Australia: "Australia/New Zealand",
  "Trinidad and Tobago": "Central America",
  "United-States": "United States",
  Uganda: "Africa",
  Rwanda: "Africa",
  Senegal: "Africa",
  Tanzania: "Africa",
  Morocco: "Africa",
  Madagascar: "Africa",
  uk: "Europe",
  "British\xA0Columbia": "British Columbia",
  Magdalena: "",
  "Cayman Islands": "Central America",
  "Cape Town": "Africa",
  "SOPHIA ANTIPOLIS": "Europe",
  \u4EAC\u90FD\u5E9C: "Asia",
  Jordan: "Asia"
};

// src/lists/lead-source-list.ts
import { z as z10 } from "zod";
import { createCustomSettings as createCustomSettings9 } from "@rootreeweb/zod-to-elements";
var leadSource = z10.union([
  z10.literal("Web"),
  z10.literal("Trade Show"),
  z10.literal("External Referral"),
  z10.literal("Other"),
  z10.literal("Ad"),
  z10.literal("Social Media"),
  z10.literal("Solicitation"),
  z10.literal("CHFA Connect"),
  z10.literal("RT Foundation 2021"),
  z10.literal("Dormant Client Activation"),
  z10.literal("Grocery Store"),
  z10.literal("CTAQ 2022"),
  z10.literal("Specialty Coffee Expo 2022"),
  z10.literal("CHFA West 2022"),
  z10.literal("SIAL 2022"),
  z10.literal("Seed To Shelf"),
  z10.literal("Beanstock 2022"),
  z10.literal("CHFA Toronto 2022"),
  z10.literal("Natural Products Expo East 2022"),
  z10.literal("RT Foundation 2022"),
  z10.literal("PLMA 2022"),
  z10.literal("OOAK 2022"),
  z10.literal("Stock Bag Clearance Campaign"),
  z10.literal("Pillow Pouch Launch"),
  z10.literal("Pouch Collective"),
  z10.literal("CHFA Vancouver 2023"),
  z10.literal("Specialty Coffee Expo 2023"),
  z10.literal("SIAL Toronto 2023"),
  z10.literal("Downtown Milton Summer Fest"),
  z10.literal("Bala Cranberry Festival 2023"),
  z10.literal("RT Staff Referral"),
  z10.literal("CHFA Toronto 2023"),
  z10.literal("Natural Products Expo East 2023"),
  z10.literal("CHFA West Vancouver 2024"),
  z10.literal("Access Labels"),
  z10.literal("SIAL 2024"),
  z10.literal("CHFA Toronto 2024"),
  z10.literal("VENTUREPARK 2024 Toronto")
]).describe(createCustomSettings9({ label: "Lead Source" }));
export {
  allLeadStatuses,
  country,
  countryLookup,
  customerStatus,
  industry,
  industryLookup,
  interestedIn,
  language,
  leadSource,
  leadStatus,
  province,
  provinceLookup,
  region,
  regionLookup,
  repIDLookup,
  salesRep,
  state,
  stateLookup
};
//# sourceMappingURL=index.js.map